// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Card, Flex, Link } from '@iheartjane/reefer';
import { mediaQueries } from '@iheartjane/reefer-emotion';

export const CATEGORY_CARD_MAX_WIDTH = 310;
export const CATEGORY_CARD_WIDTH_MOBILE = 136;
export const CATEGORY_CARD_HEIGHT = 212;
export const CATEGORY_CARD_HEIGHT_MOBILE = 72;

interface StyledCardProps {
  width?: string | number;
}

export const StyledCard = styled(Card)<StyledCardProps>(({ width }) => ({
  height: CATEGORY_CARD_HEIGHT_MOBILE,
  scrollSnapAlign: 'start',
  width: CATEGORY_CARD_WIDTH_MOBILE,
  [mediaQueries.tablet('min')]: {
    height: CATEGORY_CARD_HEIGHT,
    minWidth: 155,
    width,
  },
}));

export const StyledContentContainer = styled(Flex)({
  flexDirection: 'row',
  [mediaQueries.tablet('min')]: {
    flexDirection: 'column',
  },
});

export const StyledLink = styled(Link)(({ theme }) => ({
  display: 'block',
  height: '100%',
  textDecoration: 'none',
  width: '100%',
  ':focus-visible:before': {
    backgroundColor: theme.colors.grays.hover,
    borderRadius: 'inherit',
    content: '""',
    height: '100%',
    position: 'absolute',
    width: '100%',
  },
}));
